import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ressult() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#644BB1" }}>Results</span>
            </h2>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <p>
              The end product we have created is an app that effectively
              connects models, makeup artists, and other talents with
              recruiters, and help them stay updated with every new event and
              relevant casting calls.
            </p>
            <p>
              You can use qRoll anywhere in the world, all you need is your
              mobile and you’re good to go.
            </p>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <StaticImage
              src="../../../images/case-studies/qroll/result_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={2880}
              height={978}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ressult;
